"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networks = exports.utils = exports.Ada = void 0;
const errors_1 = require("./errors");
const invalidDataReason_1 = require("./errors/invalidDataReason");
const deriveAddress_1 = require("./interactions/deriveAddress");
const deriveNativeScriptHash_1 = require("./interactions/deriveNativeScriptHash");
const getExtendedPublicKeys_1 = require("./interactions/getExtendedPublicKeys");
const getSerial_1 = require("./interactions/getSerial");
const getVersion_1 = require("./interactions/getVersion");
const runTests_1 = require("./interactions/runTests");
const showAddress_1 = require("./interactions/showAddress");
const signCVote_1 = require("./interactions/signCVote");
const signOperationalCertificate_1 = require("./interactions/signOperationalCertificate");
const signMessage_1 = require("./interactions/signMessage");
const messageData_1 = require("./parsing/messageData");
const signTx_1 = require("./interactions/signTx");
const address_1 = require("./parsing/address");
const cVote_1 = require("./parsing/cVote");
const nativeScript_1 = require("./parsing/nativeScript");
const operationalCertificate_1 = require("./parsing/operationalCertificate");
const transaction_1 = require("./parsing/transaction");
const utils_1 = __importDefault(require("./utils"));
exports.utils = utils_1.default;
const assert_1 = require("./utils/assert");
const parse_1 = require("./utils/parse");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/public"), exports);
const CLA = 0xd7;
function wrapConvertDeviceStatusError(fn) {
    return (...args) => __awaiter(this, void 0, void 0, function* () {
        try {
            return yield fn(...args);
        }
        catch (e) {
            if (e &&
                typeof e === 'object' &&
                'statusCode' in e &&
                typeof e.statusCode === 'number') {
                throw new errors_1.DeviceStatusError(e.statusCode);
            }
            throw e;
        }
    });
}
function wrapRetryStillInCall(fn) {
    return (...args) => __awaiter(this, void 0, void 0, function* () {
        try {
            return yield fn(...args);
        }
        catch (e) {
            if (e &&
                e.statusCode &&
                e.statusCode === errors_1.DeviceStatusCodes.ERR_STILL_IN_CALL) {
                return yield fn(...args);
            }
            throw e;
        }
    });
}
function interact(interaction, send) {
    return __awaiter(this, void 0, void 0, function* () {
        let cursor = interaction.next();
        let first = true;
        while (!cursor.done) {
            const apdu = cursor.value;
            const res = first
                ? yield wrapRetryStillInCall(send)(apdu)
                : yield send(apdu);
            first = false;
            cursor = interaction.next(res);
        }
        return cursor.value;
    });
}
class Ada {
    constructor(transport, scrambleKey = 'ADA') {
        this.transport = transport;
        const methods = [
            'getVersion',
            'getSerial',
            'getExtendedPublicKeys',
            'signTransaction',
            'deriveAddress',
            'showAddress',
            'deriveNativeScriptHash',
        ];
        this.transport.decorateAppAPIMethods(this, methods, scrambleKey);
        this._send = (params) => __awaiter(this, void 0, void 0, function* () {
            if (params.data.length > 255) {
                throw new Error('APDU too large, likely a bug');
            }
            let response = yield wrapConvertDeviceStatusError(this.transport.send)(CLA, params.ins, params.p1, params.p2, params.data);
            response = utils_1.default.stripRetcodeFromResponse(response);
            if (params.expectedResponseLength != null) {
                (0, assert_1.assert)(response.length === params.expectedResponseLength, `unexpected response length: ${response.length} instead of ${params.expectedResponseLength}`);
            }
            return response;
        });
    }
    getVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            const version = yield interact(this._getVersion(), this._send);
            return { version, compatibility: (0, getVersion_1.getCompatibility)(version) };
        });
    }
    *_getVersion() {
        return yield* (0, getVersion_1.getVersion)();
    }
    getSerial() {
        return __awaiter(this, void 0, void 0, function* () {
            return interact(this._getSerial(), this._send);
        });
    }
    *_getSerial() {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, getSerial_1.getSerial)(version);
    }
    runTests() {
        return __awaiter(this, void 0, void 0, function* () {
            return interact(this._runTests(), this._send);
        });
    }
    *_runTests() {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, runTests_1.runTests)(version);
    }
    getExtendedPublicKeys({ paths, }) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, parse_1.validate)((0, parse_1.isArray)(paths), invalidDataReason_1.InvalidDataReason.GET_EXT_PUB_KEY_PATHS_NOT_ARRAY);
            const parsed = paths.map((path) => (0, parse_1.parseBIP32Path)(path, invalidDataReason_1.InvalidDataReason.INVALID_PATH));
            return interact(this._getExtendedPublicKeys(parsed), this._send);
        });
    }
    *_getExtendedPublicKeys(paths) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, getExtendedPublicKeys_1.getExtendedPublicKeys)(version, paths);
    }
    getExtendedPublicKey({ path, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getExtendedPublicKeys({ paths: [path] }))[0];
        });
    }
    deriveAddress({ network, address, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedParams = (0, address_1.parseAddress)(network, address);
            return interact(this._deriveAddress(parsedParams), this._send);
        });
    }
    *_deriveAddress(addressParams) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, deriveAddress_1.deriveAddress)(version, addressParams);
    }
    showAddress({ network, address }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedParams = (0, address_1.parseAddress)(network, address);
            return interact(this._showAddress(parsedParams), this._send);
        });
    }
    *_showAddress(addressParams) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, showAddress_1.showAddress)(version, addressParams);
    }
    signTransaction(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedRequest = (0, transaction_1.parseSignTransactionRequest)(request);
            return interact(this._signTx(parsedRequest), this._send);
        });
    }
    *_signTx(request) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, signTx_1.signTransaction)(version, request);
    }
    signOperationalCertificate(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedOperationalCertificate = (0, operationalCertificate_1.parseOperationalCertificate)(request);
            return interact(this._signOperationalCertificate(parsedOperationalCertificate), this._send);
        });
    }
    *_signOperationalCertificate(request) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, signOperationalCertificate_1.signOperationalCertificate)(version, request);
    }
    signMessage(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedMsgData = (0, messageData_1.parseMessageData)(request);
            return interact(this._signMessage(parsedMsgData), this._send);
        });
    }
    *_signMessage(request) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, signMessage_1.signMessage)(version, request);
    }
    signCIP36Vote(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedCVote = (0, cVote_1.parseCVote)(request);
            return interact(this._signCIP36Vote(parsedCVote), this._send);
        });
    }
    *_signCIP36Vote(request) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, signCVote_1.signCVote)(version, request);
    }
    deriveNativeScriptHash({ script, displayFormat, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedScript = (0, nativeScript_1.parseNativeScript)(script);
            const parsedDisplayFormat = (0, nativeScript_1.parseNativeScriptHashDisplayFormat)(displayFormat);
            return interact(this._deriveNativeScriptHash(parsedScript, parsedDisplayFormat), this._send);
        });
    }
    *_deriveNativeScriptHash(script, displayFormat) {
        const version = yield* (0, getVersion_1.getVersion)();
        return yield* (0, deriveNativeScriptHash_1.deriveNativeScriptHash)(version, script, displayFormat);
    }
}
exports.Ada = Ada;
exports.default = Ada;
exports.Networks = {
    Mainnet: {
        networkId: 0x01,
        protocolMagic: 764824073,
    },
    Testnet: {
        networkId: 0x00,
        protocolMagic: 1097911063,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWRhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0FkYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW9CQSxxQ0FBNkQ7QUFDN0Qsa0VBQTREO0FBRTVELGdFQUEwRDtBQUMxRCxrRkFBNEU7QUFDNUUsZ0ZBQTBFO0FBQzFFLHdEQUFrRDtBQUNsRCwwREFBc0U7QUFDdEUsc0RBQWdEO0FBQ2hELDREQUFzRDtBQUN0RCx3REFBa0Q7QUFDbEQsMEZBQW9GO0FBQ3BGLDREQUFzRDtBQUN0RCx1REFBc0Q7QUFDdEQsa0RBQXFEO0FBQ3JELCtDQUE4QztBQUM5QywyQ0FBMEM7QUFDMUMseURBRytCO0FBQy9CLDZFQUE0RTtBQUM1RSx1REFBaUU7QUErQmpFLG9EQUEyQjtBQXllbkIsZ0JBemVELGVBQUssQ0F5ZUM7QUF4ZWIsMkNBQXFDO0FBQ3JDLHlDQUErRDtBQUUvRCwyQ0FBd0I7QUFDeEIsaURBQThCO0FBRTlCLE1BQU0sR0FBRyxHQUFHLElBQUksQ0FBQTtBQUloQixTQUFTLDRCQUE0QixDQUFxQixFQUFLO0lBRTdELE9BQU8sQ0FBTyxHQUFHLElBQUksRUFBRSxFQUFFO1FBQ3ZCLElBQUk7WUFDRixPQUFPLE1BQU0sRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUE7U0FDekI7UUFBQyxPQUFPLENBQVUsRUFBRTtZQUNuQixJQUNFLENBQUM7Z0JBQ0QsT0FBTyxDQUFDLEtBQUssUUFBUTtnQkFDckIsWUFBWSxJQUFJLENBQUM7Z0JBQ2pCLE9BQU8sQ0FBQyxDQUFDLFVBQVUsS0FBSyxRQUFRLEVBQ2hDO2dCQUNBLE1BQU0sSUFBSSwwQkFBaUIsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUE7YUFDMUM7WUFDRCxNQUFNLENBQUMsQ0FBQTtTQUNSO0lBQ0gsQ0FBQyxDQUFBLENBQUE7QUFDSCxDQUFDO0FBcUJELFNBQVMsb0JBQW9CLENBQXFCLEVBQUs7SUFFckQsT0FBTyxDQUFPLEdBQUcsSUFBUyxFQUFFLEVBQUU7UUFDNUIsSUFBSTtZQUNGLE9BQU8sTUFBTSxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQTtTQUN6QjtRQUFDLE9BQU8sQ0FBTSxFQUFFO1lBQ2YsSUFDRSxDQUFDO2dCQUNELENBQUMsQ0FBQyxVQUFVO2dCQUNaLENBQUMsQ0FBQyxVQUFVLEtBQUssMEJBQWlCLENBQUMsaUJBQWlCLEVBQ3BEO2dCQUVBLE9BQU8sTUFBTSxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQTthQUN6QjtZQUNELE1BQU0sQ0FBQyxDQUFBO1NBQ1I7SUFDSCxDQUFDLENBQUEsQ0FBQTtBQUNILENBQUM7QUFJRCxTQUFlLFFBQVEsQ0FDckIsV0FBMkIsRUFDM0IsSUFBWTs7UUFFWixJQUFJLE1BQU0sR0FBRyxXQUFXLENBQUMsSUFBSSxFQUFFLENBQUE7UUFDL0IsSUFBSSxLQUFLLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLE9BQU8sQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFFO1lBQ25CLE1BQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUE7WUFDekIsTUFBTSxHQUFHLEdBQUcsS0FBSztnQkFDZixDQUFDLENBQUMsTUFBTSxvQkFBb0IsQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLENBQUM7Z0JBQ3hDLENBQUMsQ0FBQyxNQUFNLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtZQUNwQixLQUFLLEdBQUcsS0FBSyxDQUFBO1lBQ2IsTUFBTSxHQUFHLFdBQVcsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7U0FDL0I7UUFDRCxPQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUE7SUFDckIsQ0FBQztDQUFBO0FBTUQsTUFBYSxHQUFHO0lBU2QsWUFBWSxTQUFvQixFQUFFLFdBQVcsR0FBRyxLQUFLO1FBQ25ELElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFBO1FBRTFCLE1BQU0sT0FBTyxHQUFHO1lBQ2QsWUFBWTtZQUNaLFdBQVc7WUFDWCx1QkFBdUI7WUFDdkIsaUJBQWlCO1lBQ2pCLGVBQWU7WUFDZixhQUFhO1lBQ2Isd0JBQXdCO1NBQ3pCLENBQUE7UUFDRCxJQUFJLENBQUMsU0FBUyxDQUFDLHFCQUFxQixDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsV0FBVyxDQUFDLENBQUE7UUFDaEUsSUFBSSxDQUFDLEtBQUssR0FBRyxDQUFPLE1BQWtCLEVBQW1CLEVBQUU7WUFDekQsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sR0FBRyxHQUFHLEVBQUU7Z0JBQzVCLE1BQU0sSUFBSSxLQUFLLENBQUMsOEJBQThCLENBQUMsQ0FBQTthQUNoRDtZQUNELElBQUksUUFBUSxHQUFHLE1BQU0sNEJBQTRCLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FDcEUsR0FBRyxFQUNILE1BQU0sQ0FBQyxHQUFHLEVBQ1YsTUFBTSxDQUFDLEVBQUUsRUFDVCxNQUFNLENBQUMsRUFBRSxFQUNULE1BQU0sQ0FBQyxJQUFJLENBQ1osQ0FBQTtZQUNELFFBQVEsR0FBRyxlQUFLLENBQUMsd0JBQXdCLENBQUMsUUFBUSxDQUFDLENBQUE7WUFFbkQsSUFBSSxNQUFNLENBQUMsc0JBQXNCLElBQUksSUFBSSxFQUFFO2dCQUN6QyxJQUFBLGVBQU0sRUFDSixRQUFRLENBQUMsTUFBTSxLQUFLLE1BQU0sQ0FBQyxzQkFBc0IsRUFDakQsK0JBQStCLFFBQVEsQ0FBQyxNQUFNLGVBQWUsTUFBTSxDQUFDLHNCQUFzQixFQUFFLENBQzdGLENBQUE7YUFDRjtZQUVELE9BQU8sUUFBUSxDQUFBO1FBQ2pCLENBQUMsQ0FBQSxDQUFBO0lBQ0gsQ0FBQztJQVlLLFVBQVU7O1lBQ2QsTUFBTSxPQUFPLEdBQUcsTUFBTSxRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUM5RCxPQUFPLEVBQUMsT0FBTyxFQUFFLGFBQWEsRUFBRSxJQUFBLDZCQUFnQixFQUFDLE9BQU8sQ0FBQyxFQUFDLENBQUE7UUFDNUQsQ0FBQztLQUFBO0lBSUQsQ0FBQyxXQUFXO1FBQ1YsT0FBTyxLQUFLLENBQUMsQ0FBQyxJQUFBLHVCQUFVLEdBQUUsQ0FBQTtJQUM1QixDQUFDO0lBWUssU0FBUzs7WUFDYixPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUMsVUFBVSxFQUFFLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFBO1FBQ2hELENBQUM7S0FBQTtJQUdELENBQUMsVUFBVTtRQUNULE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxDQUFDLElBQUEsdUJBQVUsR0FBRSxDQUFBO1FBQ25DLE9BQU8sS0FBSyxDQUFDLENBQUMsSUFBQSxxQkFBUyxFQUFDLE9BQU8sQ0FBQyxDQUFBO0lBQ2xDLENBQUM7SUFLSyxRQUFROztZQUNaLE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLEVBQUUsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDL0MsQ0FBQztLQUFBO0lBR0QsQ0FBQyxTQUFTO1FBQ1IsTUFBTSxPQUFPLEdBQUcsS0FBSyxDQUFDLENBQUMsSUFBQSx1QkFBVSxHQUFFLENBQUE7UUFDbkMsT0FBTyxLQUFLLENBQUMsQ0FBQyxJQUFBLG1CQUFRLEVBQUMsT0FBTyxDQUFDLENBQUE7SUFDakMsQ0FBQztJQWNLLHFCQUFxQixDQUFDLEVBQzFCLEtBQUssR0FDd0I7O1lBRTdCLElBQUEsZ0JBQVEsRUFBQyxJQUFBLGVBQU8sRUFBQyxLQUFLLENBQUMsRUFBRSxxQ0FBaUIsQ0FBQywrQkFBK0IsQ0FBQyxDQUFBO1lBQzNFLE1BQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUNoQyxJQUFBLHNCQUFjLEVBQUMsSUFBSSxFQUFFLHFDQUFpQixDQUFDLFlBQVksQ0FBQyxDQUNyRCxDQUFBO1lBRUQsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLE1BQU0sQ0FBQyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUNsRSxDQUFDO0tBQUE7SUFHRCxDQUFDLHNCQUFzQixDQUFDLEtBQXVCO1FBQzdDLE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxDQUFDLElBQUEsdUJBQVUsR0FBRSxDQUFBO1FBQ25DLE9BQU8sS0FBSyxDQUFDLENBQUMsSUFBQSw2Q0FBcUIsRUFBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLENBQUE7SUFDckQsQ0FBQztJQU1LLG9CQUFvQixDQUFDLEVBQ3pCLElBQUksR0FDd0I7O1lBQzVCLE9BQU8sQ0FBQyxNQUFNLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxFQUFDLEtBQUssRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQy9ELENBQUM7S0FBQTtJQU1LLGFBQWEsQ0FBQyxFQUNsQixPQUFPLEVBQ1AsT0FBTyxHQUNjOztZQUNyQixNQUFNLFlBQVksR0FBRyxJQUFBLHNCQUFZLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFBO1lBRW5ELE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsWUFBWSxDQUFDLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFBO1FBQ2hFLENBQUM7S0FBQTtJQUdELENBQUMsY0FBYyxDQUNiLGFBQWtDO1FBRWxDLE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxDQUFDLElBQUEsdUJBQVUsR0FBRSxDQUFBO1FBQ25DLE9BQU8sS0FBSyxDQUFDLENBQUMsSUFBQSw2QkFBYSxFQUFDLE9BQU8sRUFBRSxhQUFhLENBQUMsQ0FBQTtJQUNyRCxDQUFDO0lBTUssV0FBVyxDQUFDLEVBQUMsT0FBTyxFQUFFLE9BQU8sRUFBcUI7O1lBQ3RELE1BQU0sWUFBWSxHQUFHLElBQUEsc0JBQVksRUFBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUE7WUFFbkQsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxZQUFZLENBQUMsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDOUQsQ0FBQztLQUFBO0lBR0QsQ0FBQyxZQUFZLENBQUMsYUFBa0M7UUFDOUMsTUFBTSxPQUFPLEdBQUcsS0FBSyxDQUFDLENBQUMsSUFBQSx1QkFBVSxHQUFFLENBQUE7UUFDbkMsT0FBTyxLQUFLLENBQUMsQ0FBQyxJQUFBLHlCQUFXLEVBQUMsT0FBTyxFQUFFLGFBQWEsQ0FBQyxDQUFBO0lBQ25ELENBQUM7SUFFSyxlQUFlLENBQ25CLE9BQStCOztZQUUvQixNQUFNLGFBQWEsR0FBRyxJQUFBLHlDQUEyQixFQUFDLE9BQU8sQ0FBQyxDQUFBO1lBRTFELE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFBO1FBQzFELENBQUM7S0FBQTtJQUdELENBQUMsT0FBTyxDQUFDLE9BQTZCO1FBQ3BDLE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxDQUFDLElBQUEsdUJBQVUsR0FBRSxDQUFBO1FBQ25DLE9BQU8sS0FBSyxDQUFDLENBQUMsSUFBQSx3QkFBZSxFQUFDLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQTtJQUNqRCxDQUFDO0lBRUssMEJBQTBCLENBQzlCLE9BQTBDOztZQUUxQyxNQUFNLDRCQUE0QixHQUFHLElBQUEsb0RBQTJCLEVBQUMsT0FBTyxDQUFDLENBQUE7WUFFekUsT0FBTyxRQUFRLENBQ2IsSUFBSSxDQUFDLDJCQUEyQixDQUFDLDRCQUE0QixDQUFDLEVBQzlELElBQUksQ0FBQyxLQUFLLENBQ1gsQ0FBQTtRQUNILENBQUM7S0FBQTtJQUdELENBQUMsMkJBQTJCLENBQzFCLE9BQXFDO1FBRXJDLE1BQU0sT0FBTyxHQUFHLEtBQUssQ0FBQyxDQUFDLElBQUEsdUJBQVUsR0FBRSxDQUFBO1FBQ25DLE9BQU8sS0FBSyxDQUFDLENBQUMsSUFBQSx1REFBMEIsRUFBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDNUQsQ0FBQztJQUVLLFdBQVcsQ0FBQyxPQUEyQjs7WUFDM0MsTUFBTSxhQUFhLEdBQUcsSUFBQSw4QkFBZ0IsRUFBQyxPQUFPLENBQUMsQ0FBQTtZQUUvQyxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLGFBQWEsQ0FBQyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUMvRCxDQUFDO0tBQUE7SUFHRCxDQUFDLFlBQVksQ0FBQyxPQUEwQjtRQUN0QyxNQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsQ0FBQyxJQUFBLHVCQUFVLEdBQUUsQ0FBQTtRQUNuQyxPQUFPLEtBQUssQ0FBQyxDQUFDLElBQUEseUJBQVcsRUFBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDN0MsQ0FBQztJQUVLLGFBQWEsQ0FDakIsT0FBNkI7O1lBRTdCLE1BQU0sV0FBVyxHQUFHLElBQUEsa0JBQVUsRUFBQyxPQUFPLENBQUMsQ0FBQTtZQUV2QyxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLFdBQVcsQ0FBQyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUMvRCxDQUFDO0tBQUE7SUFHRCxDQUFDLGNBQWMsQ0FBQyxPQUFvQjtRQUNsQyxNQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsQ0FBQyxJQUFBLHVCQUFVLEdBQUUsQ0FBQTtRQUNuQyxPQUFPLEtBQUssQ0FBQyxDQUFDLElBQUEscUJBQVMsRUFBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDM0MsQ0FBQztJQU9LLHNCQUFzQixDQUFDLEVBQzNCLE1BQU0sRUFDTixhQUFhLEdBQ2lCOztZQUM5QixNQUFNLFlBQVksR0FBRyxJQUFBLGdDQUFpQixFQUFDLE1BQU0sQ0FBQyxDQUFBO1lBQzlDLE1BQU0sbUJBQW1CLEdBQ3ZCLElBQUEsaURBQWtDLEVBQUMsYUFBYSxDQUFDLENBQUE7WUFFbkQsT0FBTyxRQUFRLENBQ2IsSUFBSSxDQUFDLHVCQUF1QixDQUFDLFlBQVksRUFBRSxtQkFBbUIsQ0FBQyxFQUMvRCxJQUFJLENBQUMsS0FBSyxDQUNYLENBQUE7UUFDSCxDQUFDO0tBQUE7SUFHRCxDQUFDLHVCQUF1QixDQUN0QixNQUEwQixFQUMxQixhQUE0QztRQUU1QyxNQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsQ0FBQyxJQUFBLHVCQUFVLEdBQUUsQ0FBQTtRQUNuQyxPQUFPLEtBQUssQ0FBQyxDQUFDLElBQUEsK0NBQXNCLEVBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxhQUFhLENBQUMsQ0FBQTtJQUN0RSxDQUFDO0NBQ0Y7QUF2UUQsa0JBdVFDO0FBd0lELGtCQUFlLEdBQUcsQ0FBQTtBQU1MLFFBQUEsUUFBUSxHQUFHO0lBQ3RCLE9BQU8sRUFBRTtRQUNQLFNBQVMsRUFBRSxJQUFJO1FBQ2YsYUFBYSxFQUFFLFNBQVM7S0FDZDtJQUNaLE9BQU8sRUFBRTtRQUNQLFNBQVMsRUFBRSxJQUFJO1FBQ2YsYUFBYSxFQUFFLFVBQVU7S0FDZjtDQUNiLENBQUEifQ==